import { isUndefined } from 'lodash';

import {
    DEFAULT_MOMENT_MONTH_FORMAT,
    DEFAULT_MONTH_DECLENSION,
    IMomentSettings,
    LANGUAGES_MOMENT_FORMAT
} from './moment';

import { LOCALE } from './locales';
import { IAvailableLanguages, LANGUAGE_REGION, LANGUAGE_REGION as REGION } from './language-regions';

// TODO: in case of extending, consider to use https://www.npmjs.com/package/language-tags or other data libs
/* eslint-disable max-len */
export const LANGUAGES_DATA = [
    { languageVariantTag: LOCALE.AR_AE, languageCode: 'ar', region: REGION.EMEA, languageVariantCode: 'ARA', languageName: 'عربى' },
    { languageVariantTag: LOCALE.CS_CZ, languageCode: 'cs', region: REGION.EMEA, languageVariantCode: 'CZE', languageName: 'Česky' },
    { languageVariantTag: LOCALE.DA_DK, languageCode: 'da', region: REGION.EMEA, languageVariantCode: 'DAN', languageName: 'Dansk' },
    { languageVariantTag: LOCALE.DE_DE, languageCode: 'de', region: REGION.EMEA, languageVariantCode: 'GER', languageName: 'Deutsch' },
    { languageVariantTag: LOCALE.EN_AU, languageCode: 'en', region: REGION.EMEA, languageVariantCode: 'AUS', languageName: 'English (Australia)' },
    { languageVariantTag: LOCALE.EN_CA, languageCode: 'en', region: REGION.NCSA, languageVariantCode: 'CAE', languageName: 'English (Canada)' },
    { languageVariantTag: LOCALE.EN_GB, languageCode: 'en', region: REGION.EMEA, languageVariantCode: 'ENG', languageName: 'English' },
    { languageVariantTag: LOCALE.EN_US, languageCode: 'en', region: REGION.NCSA, languageVariantCode: 'AME', languageName: 'English (US)' },
    { languageVariantTag: LOCALE.ES_ES, languageCode: 'es', region: REGION.EMEA, languageVariantCode: 'SPA', languageName: 'Español' },
    { languageVariantTag: LOCALE.ES_MX, languageCode: 'es', region: REGION.NCSA, languageVariantCode: 'MEX', languageName: 'Español (México)' },
    { languageVariantTag: LOCALE.FI_FI, languageCode: 'fi', region: REGION.EMEA, languageVariantCode: 'FIN', languageName: 'Suomi' },
    { languageVariantTag: LOCALE.FR_CA, languageCode: 'fr', region: REGION.NCSA, languageVariantCode: 'CAF', languageName: 'Français (Canada)' },
    { languageVariantTag: LOCALE.FR_FR, languageCode: 'fr', region: REGION.EMEA, languageVariantCode: 'FRE', languageName: 'Français' },
    { languageVariantTag: LOCALE.HU_HU, languageCode: 'hu', region: REGION.EMEA, languageVariantCode: 'HUN', languageName: 'Magyar' },
    { languageVariantTag: LOCALE.IT_IT, languageCode: 'it', region: REGION.EMEA, languageVariantCode: 'ITA', languageName: 'Italiano' },
    { languageVariantTag: LOCALE.JA_JP, languageCode: 'ja', region: REGION.EMEA, languageVariantCode: 'JPN', languageName: '日本語' },
    { languageVariantTag: LOCALE.KO_KR, languageCode: 'ko', region: REGION.EMEA, languageVariantCode: 'KOR', languageName: '한국어' },
    { languageVariantTag: LOCALE.NB_NO, languageCode: 'nb', region: REGION.EMEA, languageVariantCode: 'NBO', languageName: 'Norsk (Bokmål)' },
    { languageVariantTag: LOCALE.NL_NL, languageCode: 'nl', region: REGION.EMEA, languageVariantCode: 'DUT', languageName: 'Nederlands' },
    { languageVariantTag: LOCALE.NN_NO, languageCode: 'nn', region: REGION.EMEA, languageVariantCode: 'NNO', languageName: 'Norsk (Nynorsk)' },
    { languageVariantTag: LOCALE.PL_PL, languageCode: 'pl', region: REGION.EMEA, languageVariantCode: 'POL', languageName: 'Polski' },
    { languageVariantTag: LOCALE.PT_BR, languageCode: 'pt', region: REGION.NCSA, languageVariantCode: 'BRA', languageName: 'Português (Brasil)' },
    { languageVariantTag: LOCALE.PT_PT, languageCode: 'pt', region: REGION.EMEA, languageVariantCode: 'POR', languageName: 'Português' },
    { languageVariantTag: LOCALE.RU_RU, languageCode: 'ru', region: REGION.EMEA, languageVariantCode: 'RUS', languageName: 'Pусский' },
    { languageVariantTag: LOCALE.SV_SE, languageCode: 'sv', region: REGION.EMEA, languageVariantCode: 'SWE', languageName: 'Svenska' },
    { languageVariantTag: LOCALE.TH_TH, languageCode: 'th', region: REGION.EMEA, languageVariantCode: 'THA', languageName: 'ไทย' },
    { languageVariantTag: LOCALE.TR_TR, languageCode: 'tr', region: REGION.EMEA, languageVariantCode: 'TUR', languageName: 'Türkçe' },
    { languageVariantTag: LOCALE.UK_UA, languageCode: 'uk', region: REGION.EMEA, languageVariantCode: 'UKR', languageName: 'Українська' },
    { languageVariantTag: LOCALE.ZH_CN, languageCode: 'zh', region: REGION.EMEA, languageVariantCode: 'CHS', languageName: '简体中文' },
    { languageVariantTag: LOCALE.ZH_TW, languageCode: 'zh', region: REGION.EMEA, languageVariantCode: 'CHT', languageName: '繁體中文' }
];

/** Promo tabs have different available sets locales per region */
export const PROMOTAB_LANGUAGES = {
    [REGION.NCSA]: [LOCALE.EN_CA, LOCALE.EN_US, LOCALE.ES_MX, LOCALE.PT_BR],
    [REGION.EMEA]: [
        LOCALE.CS_CZ, LOCALE.DA_DK, LOCALE.DE_DE, LOCALE.EN_GB, LOCALE.ES_ES, LOCALE.FI_FI, LOCALE.FR_FR, LOCALE.HU_HU, LOCALE.IT_IT,
        LOCALE.JA_JP, LOCALE.KO_KR, LOCALE.NB_NO, LOCALE.NL_NL, LOCALE.PL_PL, LOCALE.PT_PT, LOCALE.RU_RU, LOCALE.SV_SE, LOCALE.TR_TR,
        LOCALE.ZH_CN, LOCALE.ZH_TW, LOCALE.TH_TH
    ]
};

export const getRegionLanguageTags = (region: LANGUAGE_REGION): string[] => {
    return LANGUAGES_DATA.filter(language => language.region === region).map(language => language.languageVariantTag);
};
export const EMEALanguages = getRegionLanguageTags(LANGUAGE_REGION.EMEA);
export const NCSALanguages = getRegionLanguageTags(LANGUAGE_REGION.NCSA);

export const ALL_DEFAULT_LANGUAGES: IAvailableLanguages = {
    [LANGUAGE_REGION.EMEA]: EMEALanguages,
    [LANGUAGE_REGION.NCSA]: NCSALanguages
};

/** Friends Referral sites have different initial locales */
export const FRIENDS_REFERRAL_DEFAULT_LANGUAGES: IAvailableLanguages = {
    [REGION.NCSA]: [LOCALE.EN_US, LOCALE.FR_CA, LOCALE.ES_MX, LOCALE.PT_BR],
    [REGION.EMEA]: [
        LOCALE.AR_AE, LOCALE.DE_DE, LOCALE.EN_GB, LOCALE.ES_ES, LOCALE.FR_FR, LOCALE.IT_IT,
        LOCALE.JA_JP, LOCALE.KO_KR, LOCALE.PL_PL, LOCALE.RU_RU, LOCALE.ZH_TW,
    ]
};

/*
 * 'ubisoft language variant code' : 'language variant tag'
 */
export const UBISOFT_LANGUAGES_MAP = LANGUAGES_DATA.reduce((result, item) => {
    result[item.languageVariantCode] = item.languageVariantTag;
    return result;
}, {});

/*
 *  'language variant tag': 'language code (iso 639-1)'
 */
export const LANGUAGES_MAP = LANGUAGES_DATA.reduce((result, item) => {
    result[item.languageVariantTag] = item.languageCode;
    return result;
}, {});

/*
 *  'language variant tag': 'language name (human readable)'
 */
export const LANGUAGE_NAMES_MAP = LANGUAGES_DATA.reduce((result, item) => {
    result[item.languageVariantTag] = item.languageName;
    return result;
}, {});

/*
 *  'language variant tag': 'language region'
 */
export const LANGUAGE_TO_REGION_MAP = LANGUAGES_DATA.reduce((result, item) => {
    result[item.languageVariantTag] = item.region;
    return result;
}, {});

/*
 *  In case Moment doesn't understand locales in the format such as 'en-GB',
 *  it will get the locale format by 'language code', such as 'en'.
 *
 *  @returns
 *  'language code': 'moment format'
 *  'locale': 'moment format'
 * */
export const LANGUAGE_FORMAT_MAP: {[key: string]: IMomentSettings} = Object.entries(LANGUAGES_MOMENT_FORMAT)
    .reduce((result, [localeKey, momentFormat]) => {
        if (!momentFormat.month) {
            momentFormat.month = DEFAULT_MOMENT_MONTH_FORMAT;
        }

        if (isUndefined(momentFormat.isMonthDeclensionNeeded)) {
            momentFormat.isMonthDeclensionNeeded = DEFAULT_MONTH_DECLENSION;
        }

        const languageCode = LANGUAGES_MAP[localeKey];
        result[localeKey] = result[languageCode] = momentFormat;
        return result;
    }, {});

export default LANGUAGES_DATA;
